import {DESIGNER_WORKFLOWS} from '../constants';
import {DesignerWorkflow} from '../types';
import {DesignerWorkflowModeChangeCompletedAction} from '../actionCreators';

const workflows = Object.values(DESIGNER_WORKFLOWS);

export function isWorkflow(
  maybeWorkflow: string
): maybeWorkflow is DesignerWorkflow {
  return workflows.some((workflow) => workflow === maybeWorkflow);
}

/**
 * Given a `DesignerWorkflowModeChangeCompletedAction` flux action, returns `true` if the actions
 * transitions into or out of Preview workflow.
 * @param action
 * @returns `true` if transitioning between Preview workflow or `false` otherwise
 */
export const isEnteringOrExitingPreview = (
  action: DesignerWorkflowModeChangeCompletedAction
) => {
  const isCurrentlyInPreview =
    action.state.DesignerStore.workflow === DESIGNER_WORKFLOWS.PREVIEW;

  if (isCurrentlyInPreview) {
    // Exiting Preview workflow
    return action.payload.workflow !== DESIGNER_WORKFLOWS.PREVIEW;
  } else {
    // Entering Preview workflow
    return action.payload.workflow === DESIGNER_WORKFLOWS.PREVIEW;
  }
};
